import { Massnahme } from "@/types/Massnahme";
import AlertService from "@/services/libs/AlertService";

export default class ValidationService {
  public static validEmail(email: string): boolean {
    if (email != undefined && email != "") {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
    return true;
  }

  public static validMassnahme(massnahme: Massnahme): boolean {
    let valid = true;
    let errorMessage = "Folgende(r) Fehler ist/sind aufgetreten: </br>";

    if (massnahme.bezeichnung === undefined || massnahme.bezeichnung === "") {
      valid = false;
      errorMessage += "Die Bezeichnung darf nicht leer sein. </br>";
    }
    if (
      massnahme.initiatorType === undefined ||
      massnahme.initiatorType.id === undefined ||
      massnahme.initiatorType.id === ""
    ) {
      valid = false;
      errorMessage += "Es muss eine Initiator-Ebene ausgewählt werden. </br>";
    }
    if (massnahme.initiator === undefined || massnahme.initiator.length === 0) {
      valid = false;
      errorMessage += "Es muss ein Initiator ausgewählt werden. </br>";
    }
    if (
      massnahme.verwaltungstraeger === undefined ||
      massnahme.verwaltungstraeger.id === undefined ||
      massnahme.verwaltungstraeger.id === ""
    ) {
      valid = false;
      errorMessage += "Es muss ein Verwaltungsträger ausgewählt werden. </br>";
    }
    if (massnahme.traeger === undefined || massnahme.traeger.length === 0) {
      valid = false;
      errorMessage += "Es muss ein Massnahmenträger ausgewählt werden. </br>";
    }
    if (
      massnahme.regionalstellen === undefined ||
      massnahme.regionalstellen.length === 0
    ) {
      valid = false;
      errorMessage +=
        "Es muss mindestens eine Zuständigkeit ausgewählt werden. </br>";
    }
    if (
      massnahme.schlagworte === undefined ||
      massnahme.schlagworte.length === 0
    ) {
      valid = false;
      errorMessage +=
        "Es muss mindestens ein Schlagwort ausgewählt werden. </br>";
    }
    if (
      massnahme.handlungsbereich === undefined ||
      massnahme.handlungsbereich.id === undefined ||
      massnahme.handlungsbereich.id === ""
    ) {
      valid = false;
      errorMessage +=
        "Es muss ein Aspekt der Massnahme ausgewählt werden. </br>";
    }
    if (
      massnahme.teilbereich === undefined ||
      massnahme.teilbereich.id === undefined ||
      massnahme.teilbereich.id === ""
    ) {
      valid = false;
      errorMessage += "Es muss eine Art der Massnahme ausgewählt werden. </br>";
    }
    if (
      massnahme.risikogewaesser === undefined ||
      massnahme.risikogewaesser.length === 0
    ) {
      valid = false;
      errorMessage +=
        "Es muss mindestens ein Risikogewässer ausgewählt werden. </br>";
    }
    if (massnahme.fertigstellung === undefined || !massnahme.fertigstellung) {
      valid = false;
      errorMessage += "Die Fertigstellung muss angegeben werden. </br>";
    }
    if (
      massnahme.status2 === undefined ||
      massnahme.status2.id === undefined ||
      massnahme.status2.id === ""
    ) {
      valid = false;
      errorMessage += "Ein Status 2 muss ausgewählt werden. </br>";
    }
    if (
      massnahme.status3 === undefined ||
      massnahme.status3.id === undefined ||
      massnahme.status3.id === ""
    ) {
      valid = false;
      errorMessage += "Ein Status 3 muss ausgewählt werden. </br>";
    }
    if (massnahme.kosten === undefined || massnahme.kosten === null) {
      valid = false;
      errorMessage += "Die Kosten müssen angegeben werden. </br>";
    }
    if (!valid) {
      AlertService.error(errorMessage);
    }
    return valid;
  }
}
